import ChatArk from './ChatArk';

function App() {
  return <ChatArk />;
}

export default App;